var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"butn"},[_c('button',{ref:"numm",staticClass:"btnn",class:{anims: _vm.animate},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }